/**
 * Europos Sąjungos (ES) šalių sąrašas – ISO 3166-1 alpha-2 kodai ir pavadinimai LT, EN, DE.
 * Naudojama visur, kur vartotojas nurodo šalį (atsiskaitymas, adresai).
 */
export const EU_COUNTRIES = [
  { code: 'AT', name_lt: 'Austrija', name_en: 'Austria', name_de: 'Österreich' },
  { code: 'BE', name_lt: 'Belgija', name_en: 'Belgium', name_de: 'Belgien' },
  { code: 'BG', name_lt: 'Bulgarija', name_en: 'Bulgaria', name_de: 'Bulgarien' },
  { code: 'HR', name_lt: 'Kroatija', name_en: 'Croatia', name_de: 'Kroatien' },
  { code: 'CY', name_lt: 'Kipras', name_en: 'Cyprus', name_de: 'Zypern' },
  { code: 'CZ', name_lt: 'Čekija', name_en: 'Czechia', name_de: 'Tschechien' },
  { code: 'DK', name_lt: 'Danija', name_en: 'Denmark', name_de: 'Dänemark' },
  { code: 'EE', name_lt: 'Estija', name_en: 'Estonia', name_de: 'Estland' },
  { code: 'FI', name_lt: 'Suomija', name_en: 'Finland', name_de: 'Finnland' },
  { code: 'FR', name_lt: 'Prancūzija', name_en: 'France', name_de: 'Frankreich' },
  { code: 'DE', name_lt: 'Vokietija', name_en: 'Germany', name_de: 'Deutschland' },
  { code: 'GR', name_lt: 'Graikija', name_en: 'Greece', name_de: 'Griechenland' },
  { code: 'HU', name_lt: 'Vengrija', name_en: 'Hungary', name_de: 'Ungarn' },
  { code: 'IE', name_lt: 'Airija', name_en: 'Ireland', name_de: 'Irland' },
  { code: 'IT', name_lt: 'Italija', name_en: 'Italy', name_de: 'Italien' },
  { code: 'LV', name_lt: 'Latvija', name_en: 'Latvia', name_de: 'Lettland' },
  { code: 'LT', name_lt: 'Lietuva', name_en: 'Lithuania', name_de: 'Litauen' },
  { code: 'LU', name_lt: 'Liuksemburgas', name_en: 'Luxembourg', name_de: 'Luxemburg' },
  { code: 'MT', name_lt: 'Malta', name_en: 'Malta', name_de: 'Malta' },
  { code: 'NL', name_lt: 'Nyderlandai', name_en: 'Netherlands', name_de: 'Niederlande' },
  { code: 'PL', name_lt: 'Lenkija', name_en: 'Poland', name_de: 'Polen' },
  { code: 'PT', name_lt: 'Portugalija', name_en: 'Portugal', name_de: 'Portugal' },
  { code: 'RO', name_lt: 'Rumunija', name_en: 'Romania', name_de: 'Rumänien' },
  { code: 'SK', name_lt: 'Slovakija', name_en: 'Slovakia', name_de: 'Slowakei' },
  { code: 'SI', name_lt: 'Slovėnija', name_en: 'Slovenia', name_de: 'Slowenien' },
  { code: 'ES', name_lt: 'Ispanija', name_en: 'Spain', name_de: 'Spanien' },
  { code: 'SE', name_lt: 'Švedija', name_en: 'Sweden', name_de: 'Schweden' },
];

const BY_CODE = Object.fromEntries(EU_COUNTRIES.map((c) => [c.code, c]));

/** Gauti šalies pavadinimą pagal kodą ir kalbą */
export function getCountryName(code, language = 'lt') {
  const c = BY_CODE[code];
  if (!c) return code || '';
  if (language === 'en') return c.name_en;
  if (language === 'de') return c.name_de;
  return c.name_lt;
}

/** Iš adreso šalies (pavadinimas arba kodas) gauti ISO kodą */
export function countryToCode(country) {
  if (!country || typeof country !== 'string') return 'LT';
  const raw = country.trim();
  const upper = raw.toUpperCase();
  if (raw.length === 2 && BY_CODE[upper]) return upper;
  const byName = EU_COUNTRIES.find(
    (c) =>
      c.name_lt === raw ||
      c.name_en === raw ||
      c.name_de === raw ||
      c.name_lt.toLowerCase() === raw.toLowerCase() ||
      c.name_en.toLowerCase() === raw.toLowerCase() ||
      c.name_de.toLowerCase() === raw.toLowerCase()
  );
  return byName ? byName.code : 'LT';
}

export default EU_COUNTRIES;
